// @flow

import * as React from 'react';

import { css } from '@emotion/core';

import mq from '../../Styles/breakpoints';

let main = css`
  width: 100%;
  
  ${mq.xxlarge(`
     width: 855px;
  `)} 
`;

export default class Main extends React.Component<any> {
  render() {
    return <div css={main}>
      { this.props.children }
    </div>;
  }
}